<template>
  <div
    v-if="currentInvestigation && currentInvestigation.hasOwnProperty('acf')"
    class="investigation-single"
    id="investigation"
  >
    <div class="xs-hide back-button pointer hide-sitemap hide-print">
      <img
        @click="goBack"
        alt="Go Back to Investigations"
        src="@/assets/icon-arrow-left.svg"
      />
    </div>
    <div
      v-if="
        isStudy(currentInvestigation) &&
        (currentInvestigation.slug === 'evros-kuzey-evidence' ||
          currentInvestigation.slug === 'evros-fady-evidence')
      "
    />
    <div
      v-else-if="!isStudy(currentInvestigation)"
      class="card border relative mx-auto"
      @click="cardOpen = true"
      :class="{ open: cardOpen }"
    >
      <div class="row clearfix flex">
        <card-block
          width="33.33"
          header="Date of Incident"
          :content="incidentDates(currentInvestigation)"
        >
        </card-block>
        <card-block
          width="33.33"
          header="Location"
          type="location"
          :content="currentInvestigation"
        >
        </card-block>

        <card-block
          width="33.33"
          header="Publication Date"
          :content="publicationDate"
        >
        </card-block>
      </div>

      <div class="row clearfix flex">
        <card-block
          width="33.33"
          :header="commissionedByHeading(currentInvestigation)"
          type="linkedOrg"
          :content="currentInvestigation.acf.commissioned_by"
          if-empty="Self-Initiated"
        >
        </card-block>

        <card-block
          width="33.33"
          header="Additional Funding"
          type="linkedOrg"
          :content="currentInvestigation.acf.funded_by"
          if-empty="None"
        >
        </card-block>

        <card-block
          width="33.33"
          header="Collaborators"
          type="linkedOrg"
          :content="currentInvestigation.acf.collaborating_organizations"
          if-empty="None"
        >
        </card-block>
      </div>

      <div class="row clearfix flex">
        <card-block
          width="33.33"
          header="Methodologies"
          type="methodologies"
          :content="currentInvestigation"
        >
        </card-block>

        <card-block
          width="33.33"
          header="Forums"
          :content="forumTitles(currentInvestigation, true)"
        >
        </card-block>

        <card-block
          width="33.33"
          header="Exhibitions"
          type="exhibitionLinks"
          :content="exhibitions"
        >
        </card-block>
      </div>

      <div class="row clearfix flex hide-print">
        <card-action
          v-if="featureVideo"
          width="33.33"
          type="video"
          :content="currentInvestigation.acf.featured.feature_video"
        >
        </card-action>

        <card-action v-else width="33.33" type="none" />

        <card-action
          width="33.33"
          type="link"
          :content="currentInvestigation.acf.featured.featured_links"
        >
        </card-action>

        <card-action
          width="33.33"
          type="blank"
          content="Media & Resources"
          @click.native="showMedia"
        >
        </card-action>
      </div>
    </div>
    <div
      v-else
      class="card border relative mx-auto"
      @click="cardOpen = true"
      :class="{ open: cardOpen }"
    >
      <div class="row clearfix flex">
        <card-block
          width="33.33"
          header="Methodologies"
          type="methodologies"
          :content="currentInvestigation"
        >
        </card-block>

        <card-block
          width="33.33"
          header="Location"
          type="location"
          :content="currentInvestigation"
        >
        </card-block>

        <card-block
          width="33.33"
          header="Publication Date"
          :content="publicationDate"
        >
        </card-block>
      </div>
    </div>

    <span
      v-waypoint="{
        active: true,
        callback: toggleNavIndex,
      }"
    ></span>

    <scrollactive
      v-if="!isStudy(currentInvestigation)"
      class="z4 investigation-nav xs-hide"
      ref="navbar"
    >
      <ul
        class="
          col-12
          menu-items
          caps
          list-reset
          max-width
          mx-auto
          center
          hide-print
        "
      >
        <li class="mx2">
          <a class="scrollactive-item is-active" v-scroll-to="'#app'"
            >Investigation</a
          >
        </li>
        <li v-if="currentInvestigation.acf.revisions" class="mx2">
          <a class="scrollactive-item is-active" v-scroll-to="'#updates'"
            >Updates</a
          >
        </li>
        <li v-if="currentInvestigation.acf.methodology_details" class="mx2">
          <a class="scrollactive-item is-active" v-scroll-to="'#methodology'"
            >Methodology</a
          >
        </li>
        <li class="mx2">
          <a class="scrollactive-item" v-scroll-to="'#team'">Team</a>
        </li>
        <li v-if="exhibitions.length" class="mx2">
          <a class="scrollactive-item" v-scroll-to="'#exhibitions'"
            >Exhibitions</a
          >
        </li>
        <li v-if="events.length" class="mx2">
          <a class="scrollactive-item" v-scroll-to="'#events'">Events</a>
        </li>
        <li v-if="press.length" class="mx2">
          <a class="scrollactive-item" v-scroll-to="'#press'">Press</a>
        </li>
        <li v-if="recognition.length" class="mx2">
          <a class="scrollactive-item" v-scroll-to="'#recognition'"
            >Recognition</a
          >
        </li>
        <li v-if="publications.length" class="mx2">
          <a class="scrollactive-item" v-scroll-to="'#publications'"
            >Publications</a
          >
        </li>
        <li v-if="relatedInvestigations.length" class="mx2">
          <a class="scrollactive-item" v-scroll-to="'#investigations'"
            >Related</a
          >
        </li>
      </ul>
    </scrollactive>
    <br v-else />

    <div v-if="featureVideo" class="video feature-video mb3 relative">
      <div class="no-jump-wrap lazy-container" v-bind:style="noJumpCss">
        <!-- Feature Video/Image -->
        <img
          class="col-12 pointer play-video no-jump-wrap-img"
          @click="
            updateCurrentVideo(
              currentInvestigation.acf.featured.feature_video[0]
            )
          "
          :data-src="featureVideoPoster.link"
          :alt="`Play Video: ${this.currentInvestigation.title}`"
          :width="featureVideoPoster.width"
          :height="featureVideoPoster.height"
        />

        <div class="button-play-video hide-print">
          {{ `Play Video → ${featureVideoLang}` }}
        </div>
      </div>

      <!-- Feature Caption -->
      <div class="feature-caption caption border hide-print">
        <div
          class="flex caps center p1 pointer play-video"
          @click="
            updateCurrentVideo(
              currentInvestigation.acf.featured.feature_video[0]
            )
          "
        >
          <div class="flex-auto">
            {{ getVideoTimeFromSeconds(videoDetails(featureVideo).duration) }}
          </div>
          <div class="flex-auto" v-if="false">
            {{ videoDetails(featureVideo).name }}
          </div>
          <div class="flex-auto">Play Video</div>
        </div>
        <div class="flex center">
          <div
            v-for="video in currentInvestigation.acf.featured.feature_video"
            @click="updateCurrentVideo(video)"
            class="
              caps
              flex-auto
              p1
              border-top border-right
              pointer
              play-video
              hover-red
              border-black
            "
            :key="video.id"
          >
            {{ video.language }}
          </div>
        </div>
      </div>
    </div>
    <div class="feature-image-item relative" v-else-if="featureImage">
      <img
        class="col-12 mb3"
        :src="featureImage.sizes.large"
        :alt="this.currentInvestigation.title"
      />
      <a
        v-if="featuredLink"
        :href="featuredLink.url"
        class="button-feature hide-print"
        target="_blank"
        ><span class="button-feature-inner">{{
          featuredLink.call_to_action
        }}</span></a
      >
      <div
        class="
          feature-image-caption
          caption
          hide-print
          pl2
          fs-xs
          col-2
          absolute
        "
      >
        <span v-html="featureImage.caption"></span>
      </div>
    </div>

    <!-- Content -->
    <div class="content lazy-container" @click="docOpenSlideshow">
      <div
        class="block-wrapper synopsis"
        v-if="currentInvestigation.acf.synopsis"
        v-html="currentInvestigation.acf.synopsis"
      ></div>

      <div
        v-for="(block, index) in currentInvestigation.acf.description"
        class="block-wrapper"
        :key="index"
        @click="handleClick"
      >
        <h3 class="block-heading mb2" v-if="block.block_heading">
          {{ block.block_heading }}
        </h3>
        <div v-if="block.block_content.columns === '1'" class="block-content">
          <div v-html="block.block_content.column_1"></div>
        </div>
        <div v-else class="block-content two-col clearfix mxn2">
          <div
            v-html="block.block_content.column_1"
            class="
              block-column
              md-col
              xs-col-12
              md-col-12
              lg-col-6
              mx-auto
              px0
              md-px2
              lg-px2
              mb2
              md-mb0
              lg-mb0
            "
          ></div>
          <div
            v-html="block.block_content.column_2"
            class="
              block-column
              md-col
              xs-col-12
              md-col-12
              lg-col-6
              px0
              md-px2
              lg-px2
            "
          ></div>
        </div>
      </div>
    </div>

    <!-- UPDATES (Revisions) -->
    <div
      id="updates"
      v-if="currentInvestigation.acf.revisions"
      class="content sans update lazy-container"
      @click="docOpenSlideshow"
    >
      <div
        v-for="(block, index) in currentInvestigation.acf.revisions"
        class="block-wrapper"
        :key="index"
        @click="handleClick"
      >
        <h3 v-if="block.acf_fc_layout === 'heading'">
          Update
          <img
            src="../assets/icon-arrow-right.svg"
            class="nolazy update-arrow"
          />
          {{ formatDate(block.date, block.format || 'DD.MM.YYYY') }}
        </h3>
        <div v-else class="block-content">
          <div v-if="block.content.columns === '1'" class="block-content">
            <div v-html="block.content.column_1"></div>
          </div>
          <div
            v-else
            class="block-content two-col clearfix mxn2 lazy-container"
          >
            <div
              v-html="block.content.column_1"
              class="
                block-column
                md-col
                xs-col-12
                md-col-12
                lg-col-6
                mx-auto
                px0
                md-px2
                lg-px2
                mb2
                md-mb0
                lg-mb0
              "
            ></div>
            <div
              v-html="block.content.column_2"
              class="
                block-column
                md-col
                xs-col-12
                md-col-12
                lg-col-6
                px0
                md-px2
                lg-px2
              "
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Methodologies -->
    <section
      v-if="currentInvestigation.acf.methodology_details"
      id="methodology"
      class="sans content lazy-container block-wrapper"
      @click="docOpenSlideshow"
    >
      <h2 class="section-heading">Methodology</h2>
      <h3 class="block-heading mx-auto mb2">Methodology</h3>
      <div
        v-for="(block, index) in currentInvestigation.acf.methodology_details"
        class="block-wrapper"
        :key="index"
      >
        <h3 class="red pt3" v-if="block.block_heading">
          {{ block.block_heading }}
        </h3>
        <div v-if="block.block_content.columns === '1'" class="block-content">
          <div v-html="block.block_content.column_1"></div>
        </div>
        <div v-else class="block-content two-col clearfix mxn2 lazy-container">
          <div
            v-html="block.block_content.column_1"
            class="
              block-column
              md-col
              xs-col-12
              md-col-12
              lg-col-6
              mx-auto
              px0
              md-px2
              lg-px2
              mb2
              md-mb0
              lg-mb0
            "
          ></div>
          <div
            v-html="block.block_content.column_2"
            class="
              block-column
              md-col
              xs-col-12
              md-col-12
              lg-col-6
              px0
              md-px2
              lg-px2
            "
          ></div>
        </div>
      </div>
    </section>

    <span id="team"></span>
    <h2 class="section-heading">Team</h2>
    <team-table
      v-if="currentInvestigation.acf.forensic_architecture_team"
      tableType="fa"
      title="Forensic Architecture Team"
      :content="currentInvestigation.acf.forensic_architecture_team"
    ></team-table>

    <team-table
      v-if="currentInvestigation.acf.forensic_oceanography_team"
      tableType="fo"
      title="Forensic Oceanography Team"
      :content="currentInvestigation.acf.forensic_oceanography_team"
    ></team-table>

    <team-table
      v-if="currentInvestigation.acf.other_team"
      tableType="other"
      :content="currentInvestigation.acf.other_team"
    ></team-table>

    <team-table
      v-if="currentInvestigation.acf.extended_team"
      tableType="extended"
      title="Extended Team"
      :content="currentInvestigation.acf.extended_team"
    ></team-table>

    <team-table
      v-if="currentInvestigation.acf.collaborating_organizations"
      tableType="collaborating_orgs"
      title="Collaborators"
      :content="currentInvestigation.acf.collaborating_organizations"
    ></team-table>

    <h2 v-if="exhibitions.length" class="section-heading">Exhibitions</h2>
    <exhibition-table
      id="exhibitions"
      v-if="exhibitions.length"
      title="Exhibitions"
      :content="exhibitions"
    ></exhibition-table>

    <h2 v-if="events.length" class="section-heading">Events</h2>
    <exhibition-table
      id="events"
      v-if="events.length"
      title="Events"
      :content="events"
    ></exhibition-table>

    <h2 v-if="press" class="section-heading">Press</h2>
    <press-table
      id="press"
      v-if="press.length"
      showTitle="true"
      :content="press"
    ></press-table>

    <h2 v-if="recognition.length" class="section-heading"></h2>
    <recognition-table
      id="recognition"
      v-if="recognition.length"
      :showTitle="true"
      :content="recognition"
    ></recognition-table>

    <h2 v-if="publications.length" class="section-heading">Publications</h2>
    <publication-table
      id="publications"
      v-if="publications.length"
      :showDescription="false"
      :content="publications"
    ></publication-table>

    <h2 v-if="relatedInvestigations.length" class="section-heading">
      Investigations
    </h2>
    <investigations-table
      id="investigations"
      v-if="relatedInvestigations.length"
      :content="relatedInvestigations"
    ></investigations-table>

    <a
      v-if="featuredLink"
      :href="featuredLink.url"
      class="featured-link"
      :class="{ show: showFeaturedLink }"
      >{{ featuredLink.call_to_action }}</a
    >

    <div id="footer-bar" class="xs-hide hide-print z3">
      <div
        id="footer-bar-items"
        class="max-width caps center fs-s reset-line-height"
      >
        <span @click="showMedia" class="item hover-red block p1 pointer"
          >Media & Resources</span
        >
      </div>
    </div>

    <transition name="fade">
      <Resources
        v-if="showResources"
        :content="currentInvestigation"
        :ss="showSlideshow"
        :documentMedia="documentMedia"
        v-on:close="hideMedia"
        v-on:open-slideshow-item="openSlideshow"
      />
    </transition>
    <transition name="fade">
      <Slideshow
        v-if="showSlideshow"
        :slideshowItems="slideshowItems"
        :slideshowIndex="slideshowIndex"
        v-on:close="showSlideshow = false"
        v-on:open-slideshow-item="openSlideshow"
      />
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import {
  getVideoTimeFromSeconds,
  isStudy,
  incidentDates,
  formatDate,
  collaborators,
  commissionedBy,
  commissionedByHeading,
  getRelated,
} from '@/utils.js'
import CardBlock from '@/components/CardBlock'
import CardAction from '@/components/CardAction'
import TeamTable from '@/components/TeamTable'
import ExhibitionTable from '@/components/ExhibitionTable'
import InvestigationsTable from '@/components/InvestigationsTable'
import PublicationTable from '@/components/PublicationTable'
import PressTable from '@/components/PressTable'
import RecognitionTable from '@/components/RecognitionTable'
import FooterBar from '@/components/FooterBar'
import Slideshow from '@/components/Slideshow'
import Resources from '@/components/Resources'
import dayjs from 'dayjs'

export default {
  name: 'Investigation',

  data() {
    return {
      active: 'investigation',
      cardOpen: false,
      documentMedia: [],
      pageSections: [
        'Investigation',
        'Team',
        'Exhibitions',
        'Press',
        'Recognition',
        'Publications',
      ],
      slug: this.$route.params.investigationSlug,
      videoPlayers: '',
      lazyContainer: this.lazyLoad({
        elements_selector: '.lazy-container img',
      }),
      showSlideshow: false,
      slideshowIndex: 0,
      repeaterInterval: null,
      showFeaturedLink: false,
    }
  },

  components: {
    CardBlock,
    CardAction,
    TeamTable,
    ExhibitionTable,
    Slideshow,
    InvestigationsTable,
    PublicationTable,
    PressTable,
    RecognitionTable,
    Resources,
    FooterBar,
  },

  metaInfo() {
    return {
      title: this.getMeta.title,
      meta: [
        { name: 'og:title', content: this.getMeta.title },
        { name: 'twitter:title', content: this.getMeta.title },
        { name: 'og:image', content: this.getMeta.image },
        { name: 'twitter:image', content: this.getMeta.image },
        {
          name: 'og:url',
          content: `${window.location.origin}/${this.$route.fullPath}`,
        },
        { name: 'og:type', content: 'website' },
        { name: 'og:description', content: this.getMeta.description },
        { name: 'twitter:description', content: this.getMeta.description },
      ],
    }
  },

  computed: {
    ...mapState(['investigations']),
    ...mapGetters([
      'currentInvestigation',
      'currentInvestigationDescription',
      // 'getInvestigationBySlug'
    ]),
    featuredLink() {
      if (
        this.currentInvestigation &&
        this.currentInvestigation.acf.featured.featured_links &&
        this.currentInvestigation.acf.featured.featured_links[0].highlight
      ) {
        return this.currentInvestigation.acf.featured.featured_links[0]
      }
    },
    featureVideoPoster() {
      return this.getVideoPoster(this.featureVideo.object)
    },
    noJumpCss() {
      return {
        paddingTop: `${
          (this.featureVideoPoster.height / this.featureVideoPoster.width) * 100
        }%`,
      }
    },
    featureImageAspect() {
      return (
        this.currentInvestigation.feature_image_dimensions.width /
        this.currentInvestigation.feature_image_dimensions.height
      )
    },
    recognition() {
      return this.getRelated(this.currentInvestigation, 'recognition')
    },
    // investigation () {
    //   return this.getInvestigationBySlug(this.slug)
    // },
    exhibitions() {
      let exhibitions = this.getRelated(this.currentInvestigation, 'exhibition')
      if (exhibitions.length >= 0) {
        exhibitions.sort(function (a, b) {
          // Start Is Before
          if (dayjs(a.start.date).isBefore(dayjs(b.start.date))) {
            return 1
          }
          // Start Is After
          if (dayjs(a.start.date).isAfter(dayjs(b.start.date))) {
            return -1
          }
          // Start Is Same
          if (dayjs(a.start.date).isSame(dayjs(b.start.date))) {
            // End Is Before
            if (dayjs(a.end.date).isBefore(dayjs(b.end.date))) {
              return 1
            }
            // End Is After
            if (dayjs(a.end.date).isAfter(dayjs(b.end.date))) {
              return -1
            }
            // End Is Same
            if (dayjs(a.end.date).isSame(dayjs(b.end.date))) {
              return 0
            }
          }
        })
        return exhibitions
      } else {
        return false
      }
    },
    exhibitionTitles() {
      if (this.exhibitions) {
        let items = []
        this.exhibitions.map((x) =>
          items.push(this.preventWidows(x.post_title))
        )
        return items.join(', ')
      } else {
        return false
      }
    },
    events() {
      let events = this.getRelated(this.currentInvestigation, 'event')
      if (events) {
        events = events.filter((event) => {
          if (event.type) {
            return event.type[0].term_id !== 55
          } else {
            return true
          }
        })
        if (events.length >= 0) {
          events.sort(function (a, b) {
            // Start Is Before
            if (dayjs(a.start.date).isBefore(dayjs(b.start.date))) {
              return 1
            } else {
              return -1
            }
          })
          return events
        }
      } else {
        return false
      }
    },
    relatedInvestigations() {
      let relatedInvestigations = this.getRelated(
        this.currentInvestigation,
        'investigation'
      )

      if (relatedInvestigations) {
        return relatedInvestigations.map((x) => {
          return this.$store.getters.allInvestigations.find((inv) => {
            return inv.id === x.ID
          })
        })
      } else {
        return false
      }
    },
    featureImage() {
      if (this.currentInvestigation.acf.featured.feature_image) {
        return this.currentInvestigation.acf.featured.feature_image
      } else {
        return false
      }
    },
    featureVideo() {
      if (this.currentInvestigation.acf.featured.feature_video) {
        return this.currentInvestigation.acf.featured.feature_video[0].video
      } else {
        return false
      }
    },
    featureVideoLang() {
      if (this.currentInvestigation.acf.featured.feature_video !== null) {
        return this.currentInvestigation.acf.featured.feature_video[0].language.toUpperCase()
      } else {
        return false
      }
    },
    funderTitles() {
      if (this.currentInvestigation.acf.funded_by !== '') {
        let items = []
        this.currentInvestigation.acf.funded_by.map((x) =>
          items.push(this.preventWidows(x.post_title))
        )
        return items.join(', ')
      } else {
        return 'None'
      }
    },
    media() {
      let mediaItems = this.currentInvestigation.acf.media

      if (this.documentMedia) {
        mediaItems = this.documentMedia.concat(mediaItems)
      }

      if (this.currentInvestigation.acf.featured.feature_video) {
        mediaItems =
          this.currentInvestigation.acf.featured.feature_video.concat(
            mediaItems
          )
      }
      return mediaItems
    },
    showResources() {
      return (
        this.currentInvestigation &&
        this.currentInvestigation.hasOwnProperty('acf') &&
        this.$route.hash === '#resources'
      )
    },
    slideshowItems() {
      // TODO: Map these out and clean to a consistent schema?
      let items = this.media.filter((item) => {
        return item.type === 'image' || item.type === 'document-image'
      })

      let itemsProcessed = items.map((x) => {
        if (x.type === 'image') {
          return {
            ID: x.ID,
            thumb: x.sizes.medium,
            large: x.sizes.large,
            full: x.url,
            caption: x.caption,
            title: x.title,
          }
        } else {
          return x
        }
      })

      return itemsProcessed
    },
    methodologyTitles() {
      if (this.currentInvestigation.acf.methodologies !== '') {
        let items = []
        this.currentInvestigation.acf.methodologies.map((x) =>
          items.push(this.preventWidows(x.post_title))
        )
        return items.join(', ')
      } else {
        return false
      }
    },
    press() {
      let items = this.getRelated(this.currentInvestigation, 'press')

      if (items) {
        items = items.sort(function (a, b) {
          return dayjs(a.date).isBefore(b.date)
        })
      }

      return items
    },
    publications() {
      return this.getRelated(this.currentInvestigation, 'publication')
    },
    publicationDate() {
      return this.formatDate(this.currentInvestigation.acf.publication_date)
    },
    getMeta() {
      if (this.currentInvestigation && this.currentInvestigation.acf) {
        return {
          title: this.titleCase(this.currentInvestigation.title),
          image: this.getVideoPoster(this.featureVideo.object).link,
          description: this.currentInvestigation.abstract,
        }
      } else {
        return false
      }
    },
  },

  mounted() {
    this.onUpdate()
    // this.checkMedia()

    this.$nextTick(() => {
      if (this.$route.hash) {
        this.$scrollTo(this.$route.hash, 300, {
          offset: -80,
        })
      } else {
        window.scrollTo(0, 0)
      }
    })
  },

  methods: {
    ...mapActions(['getInvestigation', 'updateCurrentVideo']),
    isStudy,
    incidentDates,
    formatDate,
    collaborators,
    commissionedBy,
    commissionedByHeading,
    getRelated,
    getVideoTimeFromSeconds,
    showMedia() {
      this.$router.replace({
        hash: 'resources',
      })
    },
    hideMedia() {
      this.$router.replace({
        hash: '',
      })
    },
    repeat() {
      this.lazyContainer.update()
      this.updateDocumentMedia()
    },
    goBack() {
      if (
        window.from.name === 'Investigations' ||
        window.from.name === 'Subdomain'
      ) {
        this.$router.go(-1)
      } else {
        this.$router.push({ name: 'Investigations' })
      }
    },
    toggleNavIndex({ going }) {
      if (this.$refs.navbar) {
        let nav = this.$refs.navbar.$el
        if (going === 'out') {
          nav.classList.add('ontop')
          this.showFeaturedLink = true
        } else {
          nav.classList.remove('ontop')
          this.showFeaturedLink = false
        }
      }
    },
    playVideo(e) {
      let videoJSON = JSON.parse(e.target.getAttribute('data-video-object'))
      this.updateCurrentVideo(videoJSON)
    },
    handleClick(e) {
      if (e.target.matches('.play-video')) {
        this.playVideo(e)
      }
    },
    videoDetails(video) {
      if (video.object !== '') {
        return JSON.parse(video.object)
      } else {
        return false
      }
    },
    getSlideshowIndex(id) {
      let itemId = parseInt(id)
      return this.slideshowItems
        .map(function (e) {
          return e.ID
        })
        .indexOf(itemId)
    },
    docOpenSlideshow(event) {
      let el = event.target
      if (el.classList.contains('image-ref')) {
        this.openSlideshow(this.getSlideshowIndex(el.dataset.id))
      }
    },
    updateDocumentMedia() {
      let items = Array.prototype.slice.call(
        document.querySelectorAll('.resource-reference')
      )
      let itemsProcessed = items.map((x) => {
        return {
          type: 'document-image',
          ID: parseInt(x.dataset.id),
          thumb: x.dataset.thumb,
          large: x.dataset.large,
          full: x.dataset.full,
          caption: x.dataset.caption,
          title: x.dataset.title,
        }
      })
      this.documentMedia = itemsProcessed
    },
    openSlideshow(index) {
      this.slideshowIndex = index
      this.showSlideshow = true
    },
    onUpdate() {
      this.$nextTick(() => {
        this.updateDocumentMedia()
        this.lazyContainer.update()
      })
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (from.params.investigationSlug !== to.params.investigationSlug) {
      this.getInvestigation(to.params.investigationSlug).then(() => {
        window.scrollTo(0, 0)
        next()
      })
    } else {
      next()
    }
  },
  watch: {
    currentInvestigationDescription() {
      this.onUpdate()
    },
  },
}
</script>

<style lang="css" scoped>
.block-wrapper img.update-arrow {
  display: inline-block;
  margin: 0;
  vertical-align: middle;
  margin-top: -4px;
  margin-left: 0.1em;
  margin-right: 0.1em;
  width: 16px;
  height: auto;
  margin-bottom: 0 !important;
}
.card {
  z-index: 1;
}
.ontop {
  z-index: 10;
}
.placeholder {
  background: rgb(253, 253, 253);
  min-height: 50vh;
}
.feature-image-caption {
  margin-top: -2em;
}
.synopsis {
  >>> p {
    /*color: var(--red);*/
    font-style: italic;
    padding-left: 1em;
    border-left: 1px dotted var(--red);
    margin-bottom: 0;
    padding-bottom: 1em;
  }
}

#footer-bar {
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  background: var(--col-light);
}

#footer-bar-items {
  border-top: 1px solid var(--black);

  a,
  .item {
    flex: 1;
    display: inline-block;
    padding: 1em;
  }

  ul {
    margin: 1em 0;
    li {
      display: inline-block;
    }
  }
}

.no-jump-wrap {
  position: relative;
  height: 0;

  .no-jump-wrap-img {
    background: var(--load-bg);
    position: absolute;
    top: 0;
    left: 0;
    max-width: 100%;
    height: auto;
  }

  .button-play-video,
  .button-feature {
    transform: translateX(-50%) translateY(0.25em);
  }
}

.featured-link {
  position: fixed;
  bottom: 3em;
  right: 1em;
  background: var(--red);
  color: var(--col-light);
  padding: 1em 2em;
  opacity: 0;
  pointer-events: none;
  transition: all 0.5s ease-out;

  &.show {
    opacity: 1;
    pointer-events: auto;
  }
}

@media (--phone) {
  .featured-link {
    left: 1em;
    bottom: 1em;
    text-align: center;
  }
}

@media (--breakpoint-lg) {
  .featured-link {
    bottom: 3em;
  }
}

@media (min-width: 1536px) {
  .featured-link {
    bottom: 4em;
  }
}
</style>
